import CustomerTilesPanel from "../../components/Dashboard/Tiles/CustomerTiles/CustomerTiles";
import Spinner from "../../components/SimpleComponents/Spinner/Spinner";
import { MAGIC_STRING, useMount } from "../../constants/constants";
import { useDispatch } from "react-redux";
import {
  clearAllGroupsAndProcesses,
  clearAllAggregates,
  clearAllSegments,
  resetTrendsPageState,
  clearAllShifts,
} from "providers/GlobalStateProvider";
import { useCustomersList } from "./useCustomersQuery";
import {
  useCustomerHasCounts,
  useWorkScheduleConfigJsonListAtom,
} from "store/atoms";
import { useTransition } from "react";
import { getCustomersInToken } from "components/Nav/topBarUtils";
import { useServiceStatus } from "components/SimpleComponents/TopBanner/useServiceStatus";
import { useGroupTilesFilterState } from "components/Dashboard/Tiles/GroupTile/groupTilesUtils";

export const StyledSpinner = props => (
  <div style={{ paddingTop: "3em" }} {...props}>
    <Spinner hideDuration={3000} />
  </div>
);

const CustomerTilesPage = () => {
  const dispatch = useDispatch();
  const [customersList] = useCustomersList();
  const [, setCustomerHasCounts] = useCustomerHasCounts();
  const [, setWorkScheduleConfigJsonList] = useWorkScheduleConfigJsonListAtom();
  const [, startTransition] = useTransition();
  const customersInToken = getCustomersInToken();
  const [
    {
      midgard: { breakerOpen, showBannerTimer },
    },
    setServicesStatus,
  ] = useServiceStatus();
  const [, setGroupTilesFilterState] = useGroupTilesFilterState();
  useMount(() => {
    startTransition(() => {
      // reset the counts flag when we switch customers
      setCustomerHasCounts(false);
      // reset group tiles filter state
      setGroupTilesFilterState({
        searchText: "",
        searchTextDisplay: "",
        selectedGroupNames: [],
      });
      if (
        customersInToken.length > 1 ||
        customersInToken.includes(MAGIC_STRING)
      ) {
        setWorkScheduleConfigJsonList([]);
        // if we have access to multiple tenants when landing on customer tiles page, clear the selected work schedule
      }
      // clear all processes/groups from other customers
      dispatch(clearAllGroupsAndProcesses(true));
      dispatch(clearAllShifts());
      dispatch(clearAllAggregates());
      dispatch(clearAllSegments());
      dispatch(resetTrendsPageState());
      // midgard is per-customer so if we're switching customers, reset the midgard status
      if (breakerOpen || showBannerTimer) {
        if (showBannerTimer) {
          window.clearTimeout(showBannerTimer);
        }
        setServicesStatus(prev => ({
          ...prev,
          midgard: {
            ...prev.midgard,
            breakerOpen: false,
            degraded: false,
            showBannerTimer: null,
            latestError: null,
          },
        }));
      }
    });
  });

  return customersList ? (
    <CustomerTilesPanel {...{ customersList }} />
  ) : (
    <StyledSpinner className="CustomerTilesPage-spinner" />
  );
};

export default CustomerTilesPage;
